import { memo, useCallback } from "react";

import { ColorPicker } from "@/components/ui/color";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

type Props = {
	color: string;
	errorMessage?: string;
	onChangeColor: (value: string) => void;
};

export const InputWithColorPicker = memo(({ color, onChangeColor, errorMessage }: Props) => {
	const handleChangeColor = useCallback(
		(value: string) => {
			onChangeColor(value);
		},
		[onChangeColor],
	);

	return (
		<div className="flex items-center gap-x-2">
			<InputTextField value={color} handleChange={handleChangeColor} errorMessage={errorMessage} />
			<ColorPicker color={color} size="medium" onChangeColor={onChangeColor} />
		</div>
	);
});
